import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-certificate-button.tsx
var LazyCourseCertificateButton = lazy(() => import("./certificate-button-Dh8NKbZU.js").then((n) => n.n).then((module) => ({ default: module.CertificateButton })));
function CourseCertificateButton({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-certificate-button" }),
		children: /* @__PURE__ */ jsx(LazyCourseCertificateButton, { ...props })
	});
}
function CourseCertificateButtonContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-certificate-button" }),
		children: /* @__PURE__ */ jsx(LazyCourseCertificateButton, { ...props })
	});
}
var useCourseCertificateButtonContent = () => {
	return useMemo(() => ({ courseCertificateButton: { component: CourseCertificateButtonContent } }), []);
};
//#endregion
export { CourseCertificateButton, useCourseCertificateButtonContent };
